-<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Submit Expense Report for Approval</h3>
</div>
<div class="modal-body">
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-6">
            <label><strong>Description of Submission</strong></label>
            <input type="text" class="form-control" [(ngModel)]="formData.optionDescription" [ngClass]="{invalidInput: (formData.optionDescription == null || formData.optionDescription == '')}" />
        </div>
    </div>
    <table class="table table-condensed" *ngIf="!mobileMode">
        <thead>
            <tr>
                <th>Transaction Date</th>
                <th>Description</th>
                <th>Units</th>
                <th>Unit Cost</th>
                <th>Gross Amt</th>
                <th *ngIf="showTaxAmount">Tax</th>
                <th>Charge To</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="mode == 'multi'">
                <tr *ngFor="let data of selectedData">
                    <td>{{data.ExpenseDateDisplay}}</td>
                    <td>{{data.Description}}</td>
                    <td>{{data.Units}}</td>
                    <td><span *ngIf="data.UnitCost != null">{{data.UnitCost | currency : currencySymbol}}</span><span *ngIf="data.UnitCost == null">{{0 | currency : currencySymbol}}</span></td>
                    <td><span *ngIf="data.Amount != null">{{data.Amount | currency : currencySymbol}}</span><span *ngIf="data.Amount == null">{{0 | currency : currencySymbol}}</span></td>
                    <td *ngIf="showTaxAmount"><span *ngIf="data.TaxAmount != null">{{data.TaxAmount | currency : currencySymbol}}</span><span *ngIf="data.TaxAmount == null">{{0 | currency : currencySymbol}}</span></td>
                    <td>{{data.ChargeToLabel}}</td>
                </tr>
            </ng-container>
            <tr>
                <td colspan="4" style="text-align:right;">Total: </td>
                <td>{{total | currency : currencySymbol}}</td>
                <td *ngIf="showTaxAmount"></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="mobileMode && mode == 'multi'">
        <div *ngFor="let data of selectedData;let $index = index;" style="border: 1px solid darkgray;padding:10px;margin-bottom:10px;border-radius: 5px;" data-ng-class="{backColor: $index%2==1}">
            <div><label><strong>Transaction Date: </strong></label> {{data.ExpenseDateDisplay}}</div>
            <div><label><strong>Description: </strong></label> {{data.Description}}</div>
            <div><label><strong>Units: </strong></label> {{data.Units}}</div>
            <div><label><strong>Unit Cost: </strong></label> <span *ngIf="data.UnitCost != null"> {{data.UnitCost | currency : currencySymbol}}</span><span *ngIf="data.UnitCost == null"> {{0 | currency : currencySymbol}}</span></div>
            <div><label><strong>Amt: </strong></label> <span *ngIf="data.Amount != null"> {{data.Amount | currency : currencySymbol}}</span><span *ngIf="data.Amount == null">{{0 | currency : currencySymbol}}</span></div>
            <div *ngIf="showTaxAmount"><label><strong>Tax: </strong></label> <span *ngIf="data.TaxAmount != null"> {{data.TaxAmount | currency : currencySymbol}}</span><span *ngIf="data.TaxAmount == null">{{0 | currency : currencySymbol}}</span></div>
            <div><label><strong>Charge To: </strong></label> {{data.ChargeToLabel}}</div>
        </div>
    </div>
    <hr *ngIf="showReviewer" />
    <div *ngIf="showReviewer" class="alert alert-primary">Select a primary reviewer for your expense submission</div>
    <div class="row" *ngIf="showReviewer && reviewerList.length < 1">
        <div class="col-lg-4 col-md-7 col-12">
            <label><strong>Reviewer</strong></label>
            <ng-select [items]="reviewer$ | async"
                       [hideSelected]="true"
                       [multiple]="false"
                       [typeahead]="reviewerInput$"
                       bindLabel="ReviewerName"
                       [loading]="reviewerLoading"
                       typeToSearchText="Please enter 1 or more characters"
                       [(ngModel)]="formData.selectedReviewer.Value"
                       dropdownPosition="bottom">
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-2 col-12">
            <button class="btn btn-success buttonNoLabel" tpye="button" (click)="addReviewer()" [disabled]="formData.selectedReviewer.Value == null">Add</button>
        </div>
    </div>
    <ul style="list-style:none;padding-left:0px;margin-top:25px;" *ngIf="reviewerList.length > 0">
        <li class="row">
            <div class="col-lg-5 col-md-5 col-5">
                <b>Reviewer</b>
            </div>
            <div class="col-lg-2 col-md-2 col-3"></div>
        </li>
        <div style="max-height:400px;overflow-x:hidden;">
            <li class="row" *ngFor="let data of reviewerList; let $index = index;" style="margin-bottom:5px;">
                <div class="col-lg-5 col-md-5 col-5">{{data.ReviewerName}}</div>
                <div class="col-lg-2 col-md-2 col-3"><button class="button-link" (click)="removeReviewer(data, $index)">remove</button></div>
            </li>
        </div>
    </ul>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="submitClicked()" [disabled]="formData.optionDescription == null || formData.optionDescription == '' || (showReviewer && reviewerList.length < 1) || submitting">Submit</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>